import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { accessApiExtension } from './apis';
import {
  accessAuditLogPage,
  accessBindingsPage,
  accessPage,
  accessReconcilerPage,
  accessRolesPage,
} from './pages';
import { rootRouteRef } from './routes';

/**
 * Access plugin
 * @alpha
 */

export default createFrontendPlugin({
  pluginId: 'access',
  info: { packageJson: () => import('../../package.json') },
  extensions: [
    accessApiExtension,
    accessPage,
    accessBindingsPage,
    accessRolesPage,
    accessReconcilerPage,
    accessAuditLogPage,
  ],
  routes: {
    root: rootRouteRef,
  },
});

export { accessTranslationRef } from '../translation';
